import useModifiers from 'hooks/useModifiers';
import parse from 'html-react-parser';

export enum IconListModifier {
  BIG = 'big',
  DOT = 'dot',
  PLAIN = 'plain',
  BOLD = 'bold',
  OLD = 'old',
  TABLE_SPACING = 'table_spacing',
}

export interface IconListProps {
  icon?: React.ReactElement;
  items: string[];
  modifiers?: IconListModifier[];
}

function IconList(props: IconListProps) {
  const mods = useModifiers(props.modifiers);

  return (
    <ul className={`ct_iconList ${mods}`}>
      {props.items.map((item, index) => (
        <li className="ct_iconList-item" key={index}>
          {!!props.icon && (
            <div className="ct_iconList-icon">
              {props.icon}
            </div>
          )}
          <div className="ct_iconList-content">
            {parse(item)}
          </div>
        </li>
      ))}

    </ul>
  );
}

IconList.defaultProps = { ...{} };

export default IconList;
